import AiIcon from "../assets/ai-icon.jpg";
import FundingIcon from "../assets/funding-icon.jpg";
import CofounderIcon from "../assets/cofounder-icon.jpg";

const Introduction = () => {
    return (
        <section className="intro">
            <p>Introduction</p>
            <h1>What we do</h1>
            <div className="cards">
                <div className="card">
                    <img src={AiIcon} alt="AI Tools" />
                    <h3>AI-Driven Startup Growth</h3>
                    <p>Access AI-powered tools</p>
                </div>
                <div className="card">
                    <img src={FundingIcon} alt="Funding" />
                    <h3>Funding & Mentorship</h3>
                    <p>$10K SAFE-based funding & expert guidance</p>
                </div>
                <div className="card">
                    <img src={CofounderIcon} alt="Co-Founder Matching" />
                    <h3>Co-Founder Matching</h3>
                    <p>Find the right team to build & scale</p>
                </div>
            </div>
        </section>
    );
};

export default Introduction;